export default "__VITE_ASSET__Cyu6oi6C__"